import React from "react";

export const AccessTokenContext = React.createContext({
  accessToken: "NOT_SET",
});
